export default "__VITE_ASSET__Dh27NE2o__"